module.exports = __webpack_public_path__ + "img/patent-intro.738de479.png";